module.exports = __webpack_public_path__ + "static/media/rewarded-dark.8efc59dc.png";